import { ReactElement } from "react";
import "./index.scss";
import TbLogo from "../../assets/images/tb-logo.svg";
import { Image } from "antd";
const AuthHeader = (): ReactElement => {
  return (
    <div>
      <div className={"Auth-header"}>
        <div className={"intro"}>
          <div>
            <Image
              src={TbLogo}
              preview={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthHeader;
